import { render, staticRenderFns } from "./TitleGreen.vue?vue&type=template&id=594bac40&scoped=true&"
import script from "./TitleGreen.vue?vue&type=script&lang=js&"
export * from "./TitleGreen.vue?vue&type=script&lang=js&"
import style0 from "./TitleGreen.vue?vue&type=style&index=0&id=594bac40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594bac40",
  null
  
)

export default component.exports